export default __webpack_public_path__ + "static/media/house.7c7c38a5.svg";